export default {
    success: 'Operação bem sucedida!',
}